import React from "react";
import { Input } from "../ui/input";
import { PRINTER_TYPES, PRINTER_STATUS, COMPANY_TYPES, Field, SELECT_CLS } from "./constants";

export const emptyPrinterForm = (siteId = "") => ({
    name: "", brand: "", model: "", serial_number: "", type: "laser", status: "active",
    ip_address: "", hostname: "", mac_address: "", site_id: siteId, location: "",
    purchase_date: "", purchase_price: "", purchase_currency: "CHF", warranty_end: "",
    supplier_company_id: "", maintenance_company_id: "", notes: "",
});

export const printerToForm = (p) => {
    const f = emptyPrinterForm();
    Object.keys(f).forEach((k) => { if (p[k] !== undefined && p[k] !== null) f[k] = p[k]; });
    f.purchase_date = (f.purchase_date || "").slice(0, 10);
    f.warranty_end = (f.warranty_end || "").slice(0, 10);
    return f;
};

export const buildPrinterPayload = (f) => ({
    ...f,
    purchase_price: f.purchase_price === "" ? null : Number(f.purchase_price),
    purchase_date: f.purchase_date || null,
    warranty_end: f.warranty_end || null,
    site_id: f.site_id || null,
    supplier_company_id: f.supplier_company_id || null,
    maintenance_company_id: f.maintenance_company_id || null,
});

export function CompanySelect({ value, onChange, companies, testId, placeholder = "— Aucune —" }) {
    return (
        <select value={value || ""} onChange={(e) => onChange(e.target.value)} className={SELECT_CLS} data-testid={testId}>
            <option value="">{placeholder}</option>
            {companies.map((c) => <option key={c.id} value={c.id}>{c.name}{c.type ? ` (${COMPANY_TYPES[c.type] || c.type})` : ""}</option>)}
        </select>
    );
}

export function PrinterForm({ form, setForm, sites = [], companies = [] }) {
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
    const setV = (k) => (v) => setForm({ ...form, [k]: v });
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="printer-form">
            <Field label="Nom *"><Input value={form.name} onChange={set("name")} placeholder="ex : Imprimante bureau 2e" data-testid="pf-name" /></Field>
            <Field label="Type">
                <select value={form.type} onChange={set("type")} className={SELECT_CLS} data-testid="pf-type">
                    {PRINTER_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
            </Field>
            <Field label="Marque"><Input value={form.brand} onChange={set("brand")} placeholder="HP, Canon, Brother..." data-testid="pf-brand" /></Field>
            <Field label="Modèle"><Input value={form.model} onChange={set("model")} placeholder="LaserJet Pro M404" data-testid="pf-model" /></Field>
            <Field label="N° série"><Input value={form.serial_number} onChange={set("serial_number")} className="font-mono" data-testid="pf-serial" /></Field>
            <Field label="Statut">
                <select value={form.status} onChange={set("status")} className={SELECT_CLS} data-testid="pf-status">
                    {Object.entries(PRINTER_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
            </Field>
            <Field label="Adresse IP"><Input value={form.ip_address} onChange={set("ip_address")} placeholder="192.168.1.50" className="font-mono" data-testid="pf-ip" /></Field>
            <Field label="Nom d'hôte"><Input value={form.hostname} onChange={set("hostname")} placeholder="PRN-GA24-01" className="font-mono" data-testid="pf-hostname" /></Field>
            <Field label="Site">
                <select value={form.site_id || ""} onChange={set("site_id")} className={SELECT_CLS} data-testid="pf-site">
                    <option value="">— Site par défaut —</option>
                    {sites.map((s) => <option key={s.id} value={s.id}>{s.name}{s.is_default ? " (défaut)" : ""}</option>)}
                </select>
            </Field>
            <Field label="Emplacement"><Input value={form.location} onChange={set("location")} placeholder="Étage 2, bureau 204" data-testid="pf-location" /></Field>
            <Field label="Date d'achat"><Input type="date" value={form.purchase_date} onChange={set("purchase_date")} data-testid="pf-purchase-date" /></Field>
            <Field label="Prix d'achat">
                <div className="flex gap-1">
                    <Input type="number" step="0.01" value={form.purchase_price} onChange={set("purchase_price")} placeholder="0.00" data-testid="pf-price" />
                    <Input value={form.purchase_currency} onChange={set("purchase_currency")} className="w-16 text-center" />
                </div>
            </Field>
            <Field label="Fin de garantie"><Input type="date" value={form.warranty_end} onChange={set("warranty_end")} data-testid="pf-warranty-end" /></Field>
            <Field label="Fournisseur"><CompanySelect value={form.supplier_company_id} onChange={setV("supplier_company_id")} companies={companies} testId="pf-supplier" /></Field>
            <Field label="Maintenance / SAV"><CompanySelect value={form.maintenance_company_id} onChange={setV("maintenance_company_id")} companies={companies} testId="pf-maintenance" /></Field>
            <Field label="Adresse MAC"><Input value={form.mac_address} onChange={set("mac_address")} className="font-mono" placeholder="optionnel" data-testid="pf-mac" /></Field>
            <Field label="Notes" className="sm:col-span-2">
                <textarea value={form.notes} onChange={set("notes")} rows={2} className="w-full px-2 py-1.5 text-sm border rounded-md" data-testid="pf-notes" />
            </Field>
        </div>
    );
}
